module.exports = __webpack_public_path__ + "img/whatsapp.40dd8735.svg";